import React from "react";
import "./Offer.css";

import groupsIcon from "./assets/svg/groups.svg";
import eventsIcon from "./assets/svg/events.svg";
import workshopsIcon from "./assets/svg/workshops.svg";
import arrowIcon from "./assets/svg/arrow.svg";

const Offer = () => {
  return (
    <section className="offer-section">
      <div className="container">
        <h2 className="heading-md">Mit kínálunk</h2>
        <p className="offer-subtitle body-sm">
          Elsősorban a dadogó érintetteknek és családtagjaiknak kínálunk támogató közösséget, 
          önkiteljesítési lehetőséget egy biztonságos térben, sorstársak között. 
          Programjaink és kommunikációs felületeink egyaránt szólnak a tagságnak 
          és az irántunk érdeklődőknek.
        </p>

        <div className="offer-grid">
          <div className="offer-card">
            <img
              src={groupsIcon}
              alt="Támogató csoportjaink ikon"
              className="offer-icon"
            />
            <h3 className="heading-md">Támogató csoportjaink</h3>
            <p className="body-md">
              Az egyesület belső élete úgynevezett munkacsoportokra tagolódik, hiszen saját magunknak kell megszervezni, fenntartani és működtetni ezt a civil egyesületet. A részvétel ezekben a munkacsoportokban természetesen önkéntes, és mindenki megtalálhatja a saját képességeihez, érdeklődési területéhez leginkább illőt: például egyesületi elnökség (koordináció), programszervezés, média és honlap, egyetemi és nemzetközi kapcsolatok, tudományos csoport, adminisztráció és pénzügyek, stb.
            </p>
          </div>

          <div className="offer-card">
            <img
              src={eventsIcon}
              alt="Közösségi események ikon"
              className="offer-icon"
            />
            <h3 className="heading-md">Közösségi események</h3>
            <p className="body-md">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
            <a href="/events" className="learn-more-link">
              Tudj meg többet 
              <img src={arrowIcon} alt="nyíl ikon" className="arrow-icon" />
            </a>
          </div>

          <div className="offer-card">
            <img
              src={workshopsIcon}
              alt="Workshopok ikon"
              className="offer-icon"
            />
            <h3 className="heading-md">Workshopok, tréningek</h3>
            <p className="body-md">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Offer;
